// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.click-to-hide-target[data-v-22de639c] {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    content: \" \";\n    z-index: 10;\n}\n.z-100[data-v-22de639c] {\n    z-index: 100;\n}\n", ""]);
// Exports
module.exports = exports;
